import { Cirus } from "@/classes/Http";

enum BannerSize {
    ALL = "all",
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large"
}
enum BannerLinkType {
    NONE = "none",
    URL = "url",
    PRODUCT = "product",
    CATEGORY = "category"
}

export class CreateBannerBody {
    banner_category_id: number;
    link_type: BannerLinkType;
    link: string;
    media_id: string;
    size: BannerSize;
    title: string;
    status: boolean;
}
export function createBanner(instance_id: number, params: CreateBannerBody) {
    const path = `/instance/${instance_id}/banner`;
    return Cirus.put(path, params);
}
